// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
  text-decoration: none;
  color: black;
  width: calc(25% - 16px);
  min-width: 250px;
  min-height: 200px;
  max-height: 220px;
  overflow: hidden;
}
  
.video-card:hover {
  transform: scale(1.05);
}

.video-card img {
  width: 100%;
  height: auto;
  max-height: 141px;
}

.video-card p {
  padding: 10px;
  font-weight: bold;
  /*line-height: 1em; */
  height: calc(2 * 1.3em + 20px); 
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  display: -webkit-box;
  text-align: center;
  font-size: 20px;
}

/* Responsive */
@media (max-width: 1024px) {
  .video-card {
    width: calc(33.33% - 16px); 
  }
}

@media (max-width: 768px) {
  .video-card {
    width: calc(50% - 16px); /* 2 columnas en pantallas pequeñas */
    max-height: max-content;
  }

  .video-card img {
    width: 100%;
    height: auto;
    max-height: fit-content;
  }

  .video-card p {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .video-card {
    width: 100%; /* 1 columna en móviles */
    max-height: max-content;
  }

  .video-card img {
    width: 100%;
    height: auto;
    max-height: fit-content;
  }

  .video-card p {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/videoCard/VideoCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;EACtC,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB,EAAE,qCAAqC;IAC9D,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW,EAAE,yBAAyB;IACtC,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".video-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s ease-in-out;\n  text-decoration: none;\n  color: black;\n  width: calc(25% - 16px);\n  min-width: 250px;\n  min-height: 200px;\n  max-height: 220px;\n  overflow: hidden;\n}\n  \n.video-card:hover {\n  transform: scale(1.05);\n}\n\n.video-card img {\n  width: 100%;\n  height: auto;\n  max-height: 141px;\n}\n\n.video-card p {\n  padding: 10px;\n  font-weight: bold;\n  /*line-height: 1em; */\n  height: calc(2 * 1.3em + 20px); \n  overflow: hidden;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  text-align: center;\n  font-size: 20px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .video-card {\n    width: calc(33.33% - 16px); \n  }\n}\n\n@media (max-width: 768px) {\n  .video-card {\n    width: calc(50% - 16px); /* 2 columnas en pantallas pequeñas */\n    max-height: max-content;\n  }\n\n  .video-card img {\n    width: 100%;\n    height: auto;\n    max-height: fit-content;\n  }\n\n  .video-card p {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-card {\n    width: 100%; /* 1 columna en móviles */\n    max-height: max-content;\n  }\n\n  .video-card img {\n    width: 100%;\n    height: auto;\n    max-height: fit-content;\n  }\n\n  .video-card p {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
